import { StandardEvents } from '@shopify/events';

class BmgOrderStrip extends HTMLElement {
  #version = 0;
  #abort;
  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onChange);
    document.addEventListener(StandardEvents.cartDiscountUpdate, this.#onChange);
    window.addEventListener('pageshow', this.#onPageShow);
  }
  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#onChange);
    document.removeEventListener(StandardEvents.cartDiscountUpdate, this.#onChange);
    window.removeEventListener('pageshow', this.#onPageShow);
    this.#version++;
    this.#abort?.abort();
  }
  #onPageShow = (event) => {
    if (event.persisted) this.#refresh(++this.#version);
  };
  #onChange = (event) => {
    const version = ++this.#version;
    this.#abort?.abort();
    Promise.resolve(event.promise).then((result) => {
      if (result?.detail?.didError || version !== this.#version || !this.isConnected) return;
      this.#refresh(version);
    }).catch(() => {});
  };
  async #refresh(version) {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;
    this.#abort?.abort();
    this.#abort = new AbortController();
    const url = new URL(window.location.href);
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', sectionId);
    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: this.#abort.signal });
      if (!response.ok) return;
      const sections = await response.json();
      if (version !== this.#version || !this.isConnected || !sections[sectionId]) return;
      const documentFragment = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      const replacement = documentFragment.getElementById(this.id);
      if (replacement) this.innerHTML = replacement.innerHTML;
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('Minimum order strip could not refresh.');
    }
  }
}
if (!customElements.get('bmg-order-strip')) customElements.define('bmg-order-strip', BmgOrderStrip);
